module.exports = __webpack_public_path__ + "img/vertical_6_7_4.c513b976.png";